import api from "./api";

// Category Services
export const categoryService = {
  // Get all categories with pagination
  getCategories: async (params = {}) => {
    const response = await api.get("/categories", { params });
    return response.data;
  },

  // Get all categories (for dropdowns)
  getAllCategories: async () => {
    const response = await api.get("/categories/all");
    return response.data;
  },

  // Get category by ID
  getCategoryById: async (id) => {
    const response = await api.get(`/categories/${id}`);
    return response.data;
  },

  // Create new category
  createCategory: async (categoryData) => {
    const response = await api.post("/categories", categoryData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Update category
  updateCategory: async (id, categoryData) => {
    const response = await api.put(`/categories/${id}`, categoryData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Delete category
  deleteCategory: async (id) => {
    const response = await api.delete(`/categories/${id}`);
    return response.data;
  },

  // Get all parent categories
  getParentCategories: async () => {
    const response = await api.get("/categories/parents");
    return response.data;
  },

  // Get all subcategories
  getSubcategories: async () => {
    const response = await api.get("/categories/subcategories");
    return response.data;
  },

  // Get hierarchical structure
  getHierarchical: async () => {
    const response = await api.get("/categories/hierarchical");
    return response.data;
  },

  // Get subcategories of a specific parent
  getSubcategoriesByParent: async (parentId) => {
    const response = await api.get(`/categories/${parentId}/subcategories`);
    return response.data;
  },
};
